module.exports = __webpack_public_path__ + "static/media/css3-logo.bc2328de.png";